<template lang="pug">
  .records
    .page-header
      h2 Deathrun
      select.flex-right(v-model="$route.params.map", @change="selectedMapChanged")
        template(v-for="map in maps")
          option {{ map }}

    .records-container
      .record
        h4 Score
        plus-one-icon
        .data(v-if="record.score_val && record.score_player")
          p.player {{ record.score_player | stripColor }}
          p.value {{ record.score_val }}
        .data(v-else)
          p No record

      .record
        h4 Kills
        pistol-icon
        .data(v-if="record.kills_val && record.kills_player")
          p.player {{ record.kills_player | stripColor }}
          p.value {{ record.kills_val }}
        .data(v-else)
          p No record

      .record
        h4 Knifes
        // For some reason not included in vue?
        svg(style="width:24px;height:24px" viewBox="0 0 24 24")
          path(fill="#000000" d="M22,2L17.39,3.75L10.46,10.68L14,14.22L20.92,7.29C22.43,5.78 22,2 22,2M8.33,10L6.92,11.39L8.33,12.8L2.68,18.46L6.21,22L11.87,16.34L13.28,17.76L14.7,16.34L8.33,10Z")
        .data(v-if="record.knifes_val && record.knifes_player")
          p.player {{ record.knifes_player | stripColor }}
          p.value {{ record.knifes_val }}
        .data(v-else)
          p No record

      .record
        h4 Headshots
        // For some reason not included in vue?
        svg(style="width:24px;height:24px" viewBox="0 0 24 24")
          path(fill="#000000" d="M20.95,11H22.5V13H20.95C20.5,17.17 17.17,20.5 13,20.95V22.5H11V20.95C6.83,20.5 3.5,17.17 3.05,13H1.5V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1.5H13V3.05C17.17,3.5 20.5,6.83 20.95,11M5.07,11H6.5V13H5.07C5.5,16.07 7.93,18.5 11,18.93V17.5H13V18.93C16.07,18.5 18.5,16.07 18.93,13H17.5V11H18.93C18.5,7.93 16.07,5.5 13,5.07V6.5H11V5.07C7.93,5.5 5.5,7.93 5.07,11M16,16H8V15C8,13.67 10.67,13 12,13C13.33,13 16,13.67 16,15V16M12,8A2,2 0 0,1 14,10A2,2 0 0,1 12,12A2,2 0 0,1 10,10A2,2 0 0,1 12,8Z")
        .data(v-if="record.headshots_val && record.headshots_player")
          p.player {{ record.headshots_player | stripColor }}
          p.value {{ record.headshots_val }}
        .data(v-else)
          p No record

      .record
        h4 Time
        timer-icon
        .data(v-if="record.time_val < 99999999 && record.time_player")
          p.player {{ record.time_player | stripColor }}
          p.value {{ record.time_val }}
        .data(v-else)
          p No record

      .record
        h4 Deaths
        skull-icon
        .data(v-if="record.deaths_val && record.deaths_player")
          p.player {{ record.deaths_player | stripColor }}
          p.value {{ record.deaths_val }}
        .data(v-else)
          p No record
</template>

<script>
import RecordsDeathrunService from '@/services/RecordsDeathrun';

import PlusOneIcon from 'vue-material-design-icons/PlusOne.vue';
import PistolIcon from 'vue-material-design-icons/Pistol.vue';
import TargetIcon from 'vue-material-design-icons/Target.vue';
import TimerIcon from 'vue-material-design-icons/Timer.vue';
import SkullIcon from 'vue-material-design-icons/Skull.vue';

export default {
  name: 'records-deathrun',
  components: {
    PlusOneIcon,
    PistolIcon,
    TargetIcon,
    TimerIcon,
    SkullIcon,
  },
  data() {
    return {
      record: {},
      maps: [],
    };
  },
  methods: {
    async init() {
      const response = await RecordsDeathrunService.getMaps();
      if (response.error) {
        console.log(response.error);
        return;
      }
      this.maps = response.data;

      this.update();
    },
    async update() {
      if (!this.$route.params.map) {
        const [map] = this.maps;
        this.$route.params.map = map;
      }

      const response = await RecordsDeathrunService.getRecords(this.$route.params.map);
      if (response.error) {
        console.log(response.error);
        return;
      }

      this.record = response.data;
    },
    selectedMapChanged() {
      this.$router.push({
        name: 'records-deathrun',
        params: {
          map: this.$route.params.map,
        },
      });
    },
  },
  created() {
    this.init();
  },
  watch: {
    $route() {
      this.update();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/style/definitions';

.records-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 32px 0;

  .record {
    flex-shrink: 0;
    width: calc(100% / 3);
    padding: 32px;
    position: relative;

    h4 {
      text-align: center;
      font-weight: normal;
      font-size: 20px;
    }

    svg {
      position: absolute;
      margin: 24px 0;
      left: 50%;
      transform: translateX(-50%);
      width: 48px !important;
      height: 48px !important;
      fill: $color-accent;

      path {
        fill: $color-accent;
      }
    }

    .data {
      margin-top: 84px;
      text-align: center;

      p {
        font-size: 16px;
        padding: 8px 0;
      }
    }

    @media screen and (max-width: 979px) {
      width: 50%;
    }

    @media screen and (max-width: 480px) {
      width: 100%;
    }
  }
}
</style>
